import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationSearchMatchedResponse from "../RtReconciliationSearchMatchedResponse";
import ModelProxyClass from "./ModelProxyClass";
import ReconciliationItem from "../ReconciliationItem";


/**
 * @class RtReconciliationSearchMatchedResponseBase
 * @extends ModelBaseClass
 * @property {[ReconciliationItem]} reconciliationItems
 */
class RtReconciliationSearchMatchedResponseBase extends ModelBaseClass {
	/**
	 * @type {[ReconciliationItem]} reconciliationItems
	 */
	reconciliationItems;

	/**
	 * Instantiates a new instance of RtReconciliationSearchMatchedResponse based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationSearchMatchedResponse}
	 */
	static create(genericObject) {
		const newRtReconciliationSearchMatchedResponse = new RtReconciliationSearchMatchedResponse();
		newRtReconciliationSearchMatchedResponse.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationSearchMatchedResponse;
	}

	/**
	 * Instantiates a new array of RtReconciliationSearchMatchedResponse based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationSearchMatchedResponse]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationSearchMatchedResponseArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationSearchMatchedResponseArray.push(RtReconciliationSearchMatchedResponse.create(genericObject));
		});
		return newRtReconciliationSearchMatchedResponseArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('reconciliationItems', '[ReconciliationItem]'),
];

export default RtReconciliationSearchMatchedResponseBase;
